import { Avatar, Chip } from "@nextui-org/react";
import styles from "./AccountCardMobile.module.scss";
import { getInitials } from "../../../../utils";
import { UnifiedStates } from "../../types/types";
import ChainIcon from "../../../../assets/images/icons/chain-icon.svg?react";

type ColorType =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "danger"
  | undefined;

const AccountCardMobile = ({
  legalName,
  alias,
  cvu,
  isSelected,
  onClick,
  isMirrored,
  state,
  customBottomComponent,
}: {
  legalName: string;
  alias?: string;
  cvu?: string;
  isSelected: boolean;
  isMirrored?: boolean;
  onClick: () => void;
  state?: UnifiedStates;
  customBottomComponent?: React.ReactNode;
}) => {
  const {
    container,
    icon,
    summary,
    selected,
    mirrored,
    summaryText,
    chainIcon,
  } = styles;

  const handleChipState = () => {
    let text = "";
    let color: ColorType;
    switch (state) {
      case "FAILED":
        text = "Rechazada. Contactá a soporte";
        color = "danger";
        break;
      case "IN_PROCESS":
      case "ACCOUNT_CREATION_PENDING":
        text = "Unificación en proceso";
        color = "warning";
        break;
      case "ONBOARDING_IN_PROCESS":
        text = "En proceso";
        color = "warning";
        break;
    }

    return { text, color };
  };

  const { text, color } = handleChipState();

  return (
    <div
      className={`${container} ${isSelected ? selected : ""} ${
        isMirrored ? mirrored : ""
      }`}
      onClick={isMirrored ? undefined : onClick}
    >
      <div className={icon}>
        <Avatar
          className="bg-primary-500 mr-3 text-white"
          size="md"
          name={getInitials(legalName)}
        />
      </div>
      <div className={summary}>
        <div className={summaryText}>
          <div>
            <h2>{legalName}</h2>
          </div>
          {alias && cvu && (
            <p>
              {alias} - CVU {cvu}
            </p>
          )}
        </div>
        {text && (
          <Chip color={color} radius="sm" size="sm" variant="flat">
            {text}
          </Chip>
        )}
        {customBottomComponent && customBottomComponent}
      </div>
      <div className={chainIcon}>
        <ChainIcon />
      </div>
    </div>
  );
};

export default AccountCardMobile;
